import { Map } from "mapbox-gl";
import { connect } from "react-redux";
import { ApplicationState } from "../reducers";
import { CalculatedTiming } from "../model/timing";
import along from "@turf/along";
//@ts-ignore
import distance from "@turf/distance";
import { MapViewType } from "./MapViewType";
import { GunshotObservation } from "../model/rounds";

export interface MapboxProps {
  calculatedTiming?: CalculatedTiming;
  round?: GunshotObservation;
}

export interface OwnProps {
  map: Map;
  loaded: boolean;
  mapType?: MapViewType;
}

export interface Props extends OwnProps, MapboxProps {}

function addTimingLayer(map: Map) {
  map.addLayer({
    id: "bullet",
    paint: {
      "line-color": "red",
      "line-width": 5
      // 'line-gradient' must be specified using an expression
      // with the special 'line-progress' property
    },
    layout: {
      "line-cap": "round",
      "line-join": "round"
    },
    source: "bullet",
    type: "line"
  });
}

function addTimingSource(map: Map, calculatedTiming?: CalculatedTiming, round?: GunshotObservation) {
  map.addSource("bullet", {
    lineMetrics: true,
    data: createSupersonicLine(calculatedTiming, round),
    type: "geojson"
  });
}

export const createSupersonicLine = (
  timing?: CalculatedTiming,
  round?: GunshotObservation
): GeoJSON.FeatureCollection => {
  const features = [];

  if (timing?.subsonicTransitionPoint && round && round.target) {
    const distanceToImpact = distance([round.device.position.master.lon,round.device.position.master.lat], [round.target.position.lon,round.target.position.lat]);
    const distanceToSubsonicPoint = distance([round.device.position.master.lon,round.device.position.master.lat], [timing.subsonicTransitionPoint.longitude,timing.subsonicTransitionPoint.latitude]);
    console.log([round.device.position.master.lon,round.device.position.master.lat], [round.target.position.lon,round.target.position.lat], distanceToImpact, distanceToSubsonicPoint, [round.device.position.master.lon,round.device.position.master.lat], [timing.subsonicTransitionPoint.longitude,timing.subsonicTransitionPoint.latitude]);
      // @ts-ignore
    features.push({
      geometry: {
        coordinates: [
          [round.device.position.master.lon, round.device.position.master.lat],
          // Use subsonic transition point if its closer than the impact point, else use the impact point
          distanceToImpact > distanceToSubsonicPoint ? [timing.subsonicTransitionPoint.longitude, timing.subsonicTransitionPoint.latitude] : [round.target.position.lon, round.target.position.lat]
        ],
        type: "LineString"
      },
      id: `gunshot2impact`,
      properties: {
        id: `gunshot2impact`
      },
      type: "Feature"
    });
  }
  return {
    features,
    type: "FeatureCollection"
  };
};



function updateTimingSource(map: Map, calculatedTiming?: CalculatedTiming, round?:GunshotObservation) {
  map
    .getSource("bullet")
    // @ts-ignore
    .setData(createSupersonicLine(calculatedTiming, round));
}

const BulletLayer = ({ map, loaded, calculatedTiming, round }: Props) => {
  if (map && loaded) {
    if (!map.getSource("bullet")) {
      addTimingSource(map, calculatedTiming, round);
      addTimingLayer(map);
    } else {
      updateTimingSource(map, calculatedTiming, round);
    }
  }

  return null;
};

const mapStateToProps = (state: ApplicationState) => {
  const selectedRound = state.round.selectedRound;
  const observation =
    selectedRound &&
    selectedRound.observations.find(
      o => o.device.name === state.round.selectedDevice
    );

  return {
    calculatedTiming: observation ? observation.calculatedTiming : undefined,
    round: observation
  };
};

// @ts-ignore
export default connect<MapboxProps, {}, {}>(mapStateToProps)(BulletLayer);
